import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface DrawerState {
  isDrawerOpen: boolean
  setIsDrawerOpen: (shouldOpen: boolean) => void
}

export const useDrawer = create<DrawerState>()(
  devtools((set) => ({
    isDrawerOpen: false,
    setIsDrawerOpen: (shouldOpen) => set({ isDrawerOpen: shouldOpen }),
  })),
)
